import React from 'react';

interface SpinnerProps {
  size?: 'sm' | 'lg'; // Optional size
  message?: string; // Optional loading message
  spinnerClass?: string; // Class for positioning and styling
}

const Spinner: React.FC<SpinnerProps> = ({ size = 'lg', message = 'Loading...', spinnerClass = '' }) => {
  const spinnerClassName = size === 'sm' ? 'spinner-border spinner-border-sm' : 'spinner-border';

  return (
    <div className={`spinner-wrapper ${spinnerClass}`}>
      <div className={spinnerClassName} role="status">
        <span className="visually-hidden">{message}</span>
      </div>
      {message && <span className="ms-2">{message}</span>}
    </div>
  );
};

export default Spinner;